var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "max-w-6xl mx-auto sm:px-6 lg:px-8 xl:px-0 px-4 lg:my-12 my-4",
    },
    [
      _vm.$fetchState.pending
        ? _c("div", [_c("main-loading")], 1)
        : _vm.$fetchState.error
        ? _c("div", [_vm._v("An error occurred")])
        : _c(
            "div",
            [
              _c("header-crud", {
                attrs: {
                  categories: _vm.categories,
                  name: _vm.$t("e-learning"),
                },
                on: { handleFilter: _vm.handleFilter },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "grid md:grid-cols-3 gap-6 sm:grid-cols-2 grid-cols-1",
                },
                _vm._l(_vm.data, function (video, index) {
                  return _c(
                    "div",
                    { key: index },
                    [_c("video-card", { attrs: { data: video } })],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.pagination.pageCount > 1
                ? _c("pagination", {
                    attrs: {
                      pageCount: _vm.pagination.pageCount,
                      pageSize: _vm.pagination.pageSize,
                      page: _vm.pagination.page,
                    },
                    on: {
                      onChange: function ($event) {
                        return _vm.changePage($event)
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }